export const state = () => ({
  notifications: {},
  webPushLastSubscriptionRequest: 0,
  loading: false,
})

export const mutations = {
  setLoading: (state, value) => (state.loading = value),
  setNotifications: (state, value) => (state.notifications = value),
  updateEvent: (state, value) => {
    state.notifications = {
      ...state.notifications,
      events: state.notifications.events.map(event => {
        if (event.referenceDocument._id === value._id) {
          return {
            ...event,
            ...value,
          }
        }
        return event
      }),
    }
  },
  updateEventPresence: (state, value) => {
    const { id, employeeCode, status } = value
    const setByPresenceStatus = {
      maybe: () => {
        state.notifications = {
          ...state.notifications,
          events: state.notifications.events.map(event => {
            if (event.referenceDocument._id === id) {
              return {
                ...event,
                referenceDocument: {
                  ...event.referenceDocument,
                  confirmedEmployeesCode: event.referenceDocument.confirmedEmployeesCode?.filter(
                    code => code !== employeeCode
                  ),
                  declinedEmployeesCode: event.referenceDocument.declinedEmployeesCode?.filter(
                    code => code !== employeeCode
                  ),
                },
              }
            }
            return event
          }),
        }
      },
      confirm: () => {
        state.notifications = {
          ...state.notifications,
          events: state.notifications.events.map(event => {
            if (event.referenceDocument._id === id) {
              return {
                ...event,
                referenceDocument: {
                  ...event.referenceDocument,
                  confirmedEmployeesCode: [
                    ...event.referenceDocument.confirmedEmployeesCode,
                    employeeCode,
                  ],
                  declinedEmployeesCode: event.referenceDocument.declinedEmployeesCode?.filter(
                    code => code !== employeeCode
                  ),
                },
              }
            }
            return event
          }),
        }
      },
      decline: () => {
        state.notifications = {
          ...state.notifications,
          events: state.notifications.events.map(event => {
            if (event.referenceDocument._id === id) {
              return {
                ...event,
                referenceDocument: {
                  ...event.referenceDocument,
                  declinedEmployeesCode: [
                    ...event.referenceDocument.declinedEmployeesCode,
                    employeeCode,
                  ],
                  confirmedEmployeesCode: event.referenceDocument.confirmedEmployeesCode?.filter(
                    code => code !== employeeCode
                  ),
                },
              }
            }
            return event
          }),
        }
      },
    }
    setByPresenceStatus[status]()
  },
  removeNotification: (state, id) => {
    state.notifications = Object.fromEntries(
      Object.entries(state.notifications).map(([key, value]) => [
        key,
        value.filter(item => item._id !== id),
      ])
    )
  },
  removeAllNotifications: state => {
    state.notifications = {}
  },
  setWebPushLastSubscriptionRequest: state =>
    (state.webPushLastSubscriptionRequest = Date.now()),
}

export const actions = {
  async getNotifications({ commit, state }) {
    commit('setLoading', true)
    try {
      const { data } = await this.$axios.get('/v3/app/notification')
      commit('setNotifications', data)
    } catch (error) {
      console.error(error)
    }
    commit('setLoading', false)
  },
  async updateEventPresence({ commit, state, rootState }, { id, status }) {
    const oldEvent = state.notifications.events.filter(
      event => event._id === id
    )[0]
    commit('updateEventPresence', {
      id,
      employeeCode: rootState.auth.user.employeeCode,
      status,
    })
    try {
      await this.$axios.put(`/v3/app/calendar/presence/${id}`, {
        presenceStatus: status,
      })
    } catch {
      commit('updateEvent', oldEvent)
      console.error(error)
      throw error
    }
  },
  async removeNotificationItem({ commit, state }, id) {
    const oldValue = state.notifications
    commit('removeNotification', id)
    try {
      await this.$axios.delete(`/v3/app/notification/remove/${id}`)
    } catch (error) {
      console.error(error)
      commit('setNotifications', oldValue)
      throw error
    }
  },
  async removeAllNotifications({ commit, state }) {
    const oldValue = state.notifications
    commit('removeAllNotifications')
    try {
      await this.$axios.delete('/v3/app/notification/remove-all')
    } catch (error) {
      console.error(error)
      commit('setNotifications', oldValue)
      throw error
    }
  },
  async setAllToSeen({ commit, dispatch, state }) {
    const oldValue = state.notifications
    try {
      await this.$axios.put('/v3/app/notification/seen-all')
      dispatch('getNotifications')
    } catch (error) {
      console.error(error)
      commit('setNotifications', oldValue)
    }
  },
}
